/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc PC端设置密码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  userLoginPasswordDTO: member.UserLoginPasswordDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/pc/setting/password`,
    data: userLoginPasswordDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
